import {CHANGE_TESTIMONIALS_DATA} from '../../actions/types';

const initialState = {
  testimonials: [],
};

export default (state = initialState, action) => {
  if (action.type === CHANGE_TESTIMONIALS_DATA) {
    return {
      testimonials: action.payload,
    };
  } else return state;
}
